export const set = property => (state, payload) => (state[property] = payload)

export const toggle = property => state => (state[property] = !state[property])

export const get = property => state => { return state[property] }

export const add = property => (state, payload) => state[property].push(payload)

export const remove = (property, key) => (state, payload) => { state[property] = state[property].filter(el => el[key] !== payload[key]) }

export const setNested = property => (state, payload) => {
  let nest = property.split('.')
  let position = null
  nest.forEach((element, index) => {
    if (index !== (nest.length - 1)) {
      position = state[element]
    } else {
      position[element] = payload
    }
  })
}

export const toggleNested = property => state => {
  let nest = property.split('.')
  let position = null
  nest.forEach((element, index) => {
    if (index !== (nest.length - 1)) {
      position = state[element]
    } else {
      position[element] = !position[element]
    }
  })
}

export const getNested = property => state => {
  let nest = property.split('.')
  let position = null
  nest.forEach((element, index) => {
    if (index !== (nest.length - 1)) {
      position = state[element]
    } else {
      position = position[element]
    }
  })

  return position
}
